<p-table
    columnResizeMode="expand"
    [value]="filterPorPaso(this.personas,paso) " [paginator]="true"
    styleClass="p-datatable-gridlines p-datatable-sm" [rows]="5" [showCurrentPageReport]="true"
    responsiveLayout="stack" [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} personas"
    [rowsPerPageOptions]="[5, 10, 25, 50]">
    <ng-template pTemplate="header">
        <tr>
            <th style="width:25%">Nombre</th>
            <th style="width:25%">Número de documento</th>
            <th style="width:25%">Archivo</th>
            <th style="width:15%">Operación</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-personas let-index="rowIndex">
        <tr>
            <td>
                <div class="text-lg font-medium text-900 mt-2">{{ personas.personaInfo.nombres }}</div>
                <span class="font-medium text-secondary text-sm">{{ personas.tipo_propietario }}</span>
            </td>
            <td>
                {{ this.personasService.findDocumentoFirst(personas.personaInfo.documentos)?.documento }}
            </td>
            <td>
                <div class="flex flex-row">
                    <div class="inline-block vertical-align-middle">
                        <i class="pi pi-upload mr-2"></i>
                        <span class="ml-1 mt-1">{{ personas.nombreArchivo }}</span>
                    </div>
                    <div class="ml-1">
                        <p-tag styleClass="text-xs" severity="warning" [pTooltip]="'Debe volver a ingresar los archivos se perdieron cuando se recargo la pagina'"
                               icon="pi pi-exclamation-triangle" [hidden]="personas.pageRefresh!==true"/>
                    </div>
                </div>
            </td>
            <td>
                <div class="flex flex-row justify-content-center">
                    <p-button (onClick)="eliminarPropietario(index,paso)"
                              pTooltip="Eliminar persona"
                              icon="pi pi-trash"
                              styleClass="p-button-rounded p-button-danger p-button-text">
                    </p-button>

                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

